<style scoped lang="scss">
  .wrap-reset{
    background: #F8F8F8;
    padding:40px 0;
    .container{
      background: #fff;
      width: 1000px;
      padding:40px 250px;
    }
    .title{
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 40px;
    }
  }
</style>
<template>
  <div class="wrap wrap-reset">
    <section class="container" v-show="!showSuccess">
      <div class="title">重置密码</div>
      <el-form :model="forgetForm" ref="forgetForm" :rules="forgetFormRules" label-width="120px">
        <el-form-item label="原密码" prop="originalPwd">
          <el-input type="password" v-model="forgetForm.originalPwd"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input type="password" v-model="forgetForm.newPwd"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmNewPwd">
          <el-input type="password" v-model="forgetForm.confirmNewPwd"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onsubmit('forgetForm')">确认</el-button>
        </el-form-item>
      </el-form>
    </section>
    <div class="success" v-show="showSuccess">
      <img src="@/assets/images/icon_success.png">
      <h2>密码重置成功</h2>
      <router-link to="/login">重新登陆</router-link>
    </div>
  </div>
</template>

<script>
import { changePassword } from '../services/api.index'
export default {
  data () {
    return {
      showSuccess: false,
      forgetForm: {
        originalPwd: '',
        newPwd: '',
        confirmNewPwd: ''
      },
      forgetFormRules: {
        originalPwd: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        confirmNewPwd: [{ required: true, message: '请输入确认新密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onsubmit (formName) {
      const { originalPwd, newPwd, confirmNewPwd } = this.forgetForm
      this.$refs[formName].validate((valid) => {
        if (valid) {
          changePassword(originalPwd, newPwd, confirmNewPwd).then(() => {
            this.$message.success('密码修改成功')
            this.baseMethods.hrefUrl('/login')
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/forget.vue